import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/css/style.css";
import "@/assets/css/typography.css";
import PrimaryButton from "./components/PrimaryButton.vue";
import OutlineButton from "./components/OutlineButton.vue";
import SingleSelect from "./components/SingleSelect.vue";
import Loader from "./components/Loader.vue";
import TextField from "./components/TextField.vue";
import store from "./store";
import Vuelidate from "vuelidate";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import SearchBar from "./components/SearchBar.vue";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component("PButton", PrimaryButton);
Vue.component("OButton", OutlineButton);
Vue.component("SingleSelect", SingleSelect);
Vue.component("TextField", TextField);
Vue.component("Loader", Loader);
Vue.component("datetime", Datetime);
Vue.component("SearchBar", SearchBar);

Vue.use(Vuelidate);

let handleOutsideClick;
Vue.directive("closable", {
	bind(el, binding, vnode) {
		// Here's the click/touchstart handler
		// (it is registered below)
		handleOutsideClick = (e) => {
			e.stopPropagation();
			// Get the handler method name and the exclude array
			// from the object used in v-closable
			const { handler, exclude } = binding.value;
			// This variable indicates if the clicked element is excluded
			let clickedOnExcludedEl = false;
			exclude.forEach((refName) => {
				// We only run this code if we haven't detected
				// any excluded element yet
				if (!clickedOnExcludedEl) {
					let excludedEl = vnode.context.$refs[refName];
					excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
					// Get the element using the reference name
					// See if this excluded element
					// is the same element the user just clicked on
					if (excludedEl) {
						// See if this excluded element
						// is the same element the user just clicked on
						clickedOnExcludedEl = excludedEl.contains(e.target);
					}
				}
			});
			// We check to see if the clicked element is not
			// the dialog element and not excluded
			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				// If the clicked element is outside the dialog
				// and not the button, then call the outside-click handler
				// from the same component this directive is used in
				vnode.context[handler]();
			}
		};
		// Register click/touchstart event listeners on the whole page
		document.addEventListener("click", handleOutsideClick);
	},
	unbind() {
		// If the element that has v-closable is removed, then
		// unbind click/touchstart listeners from the whole page
		document.removeEventListener("click", handleOutsideClick);
	},
});
new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
